import * as React from 'react'
import type { SVGProps } from 'react'
function SvgOnlineDienste227212823116(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 272.3 306.8"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M244.3,61.2h-10c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h10c11.5,0,20.9,9.4,20.9,20.9v137.6c0,11.5-9.4,20.9-20.9,20.9 h-77.7h-60.9H28c-11.5,0-20.9-9.4-20.9-20.9V89.2c0-11.5,9.4-20.9,20.9-20.9h10c2,0,3.6-1.6,3.6-3.6S40,61.2,38,61.2H28 c-15.5,0-28,12.6-28,28v137.6c0,15.5,12.6,28,28,28l74.1,0v44.8h-9.6c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6h13.2h60.9h13.2 c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6h-9.6v-44.8l74.1,0c15.5,0,28-12.6,28-28V89.2C272.3,73.8,259.8,61.2,244.3,61.2z  M163.1,299.7h-53.8v-44.8h53.8V299.7z" />
        <path d="M23.6,221.6c0,2,1.6,3.6,3.6,3.6h218.1c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6H27.1C25.2,218.1,23.6,219.7,23.6,221.6z" />
        <path d="M58.4,166c2,0,3.6-1.6,3.6-3.6V7.1h108v36.8c0,2,1.6,3.6,3.6,3.6h36.8v114.9c0,2,1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6V43.9 c0,0,0-0.1,0-0.1c0-0.4-0.1-0.9-0.3-1.3c0,0,0,0,0,0c-0.1-0.2-0.2-0.4-0.3-0.6c0,0,0,0,0,0c-0.1-0.2-0.3-0.4-0.4-0.5L176.1,1 c-0.2-0.2-0.3-0.3-0.5-0.4c0,0,0,0,0,0c-0.2-0.1-0.4-0.2-0.6-0.3c0,0,0,0-0.1,0C174.5,0.1,174,0,173.6,0c0,0,0,0,0,0H58.4 c-2,0-3.6,1.6-3.6,3.6v158.9C54.9,164.4,56.4,166,58.4,166z M205.3,40.4h-28.2V12.2l14.1,14.1L205.3,40.4z" />
        <path d="M152.3,51.9c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6H120c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6H152.3z" />
        <path d="M95.2,83.7c0,2,1.6,3.6,3.6,3.6h74.8c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6H98.8C96.8,80.2,95.2,81.8,95.2,83.7z" />
        <path d="M98.8,117.4h74.8c2,0,3.6-1.6,3.6-3.6s-1.6-3.6-3.6-3.6H98.8c-2,0-3.6,1.6-3.6,3.6S96.8,117.4,98.8,117.4z" />
      </g>
    </svg>
  )
}
export default SvgOnlineDienste227212823116
